import NavBar from "components/layout/NavBar";
import Footer from "components/layout/Footer";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";

const Layout: React.FC = () => {
  const { pathname } = useLocation();
  const hasFixedBottomBar =
    pathname.includes("frame-details") || pathname.includes("contact-details");

  return (
    <div>
      <NavBar />
      <main className="pt-3 overflow-x-hidden">
        <Outlet />
      </main>
      <Footer />
      {/* Spacer so layout Footer is not covered by page fixed bottom bar on mobile */}
      {hasFixedBottomBar && (
        <div className="md:hidden h-28 flex-shrink-0" aria-hidden />
      )}
    </div>
  );
};

export default Layout;
